import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import TextButton from "../designSystem/buttons/TextButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import Accordion from "../designSystem/Accordion";
import CharityPartners1 from "../../assets/images/charity_ourpartner.png";
import CharityPartners2 from "../../assets/images/charity_whythismatters.png";
import CharityPartners3 from "../../assets/images/charity_makingadifference.png";
import { useNavigate } from "react-router-dom";

const CharityPartnerships = () => {
  const navigate = useNavigate();
  return (
    <div>
      <SEO
        title="Charity Partnerships"
        description="Learn about AK Mortgages' charity partnership with Ignite Life and our commitment to supporting young people and families in Bristol."
        path="/about-us/charity-partnerships"
      />
      <Hero
        title={`SUPPORTING OUR COMMUNITY`}
        subtitle="CHARITY PARTNERSHIPS"
        titleAlign="center"
        subtitleAlign="center"
      >
        <div className="column-center gap-s">
          <div className="content text-primary-1">
            At AK Mortgages, we believe that supporting people goes beyond
            helping them buy a home. Strong communities are built by investing
            in the people who need support the most, which is why we are proud
            to partner with{" "}
            <span className="text-primary-2">
              <a
                href="https://www.ignite-life.co.uk/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-2"
              >
                Ignite Life
              </a>
            </span>
            .
          </div>
        </div>
      </Hero>
      <div className="background-container bg-white">
        <div className="content-container row gap-xxxxxl">
          <img src={CharityPartners1} alt="Ignite Life charity partnership" className="hero-image" />
          <div className="column gap-l">
            <h2 className="text-primary-1 uppercase">
              OUR CHARITY PARTNER: IGNITE LIFE
            </h2>
            <div className="column gap-m">
              <div className="column gap-s">
                <div className="content text-primary-1">
                  Ignite Life is a youth charity based in Kingswood, Bristol,
                  dedicated to supporting young people and families facing
                  disadvantage. Through one-to-one mentoring, one-to-one
                  counselling, and a community food bank, the charity provides
                  practical and emotional support to those experiencing
                  challenges such as poor mental health, poverty, food
                  insecurity, and barriers to education and employment.
                </div>
                <div className="content text-primary-1">
                  Their work is more important than ever. Across Bristol, many
                  young people are not in education, employment or training,
                  while increasing numbers of families are experiencing
                  financial hardship and food insecurity. Ignite Life works
                  alongside each individual and family, providing tailored
                  support that helps build confidence, resilience, and brighter
                  futures.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-3">
        <div className="content-container row-reverse gap-xxxxxl">
          <div className="column gap-l">
            <div className="column gap-s">
              <h3 className="text-primary-1 uppercase">
                WHY THIS PARTNERSHIP MATTERS
              </h3>
            </div>
            <div className="column gap-m">
              <div className="content-semibold text-primary-1">
                For our founder, Ashley, supporting Ignite Life is deeply
                personal.
              </div>
              <div className="content text-primary-1">
                Before becoming a mortgage broker, Ashley worked for a company
                that worked alongside Ignite Life called Impact Mentoring.
                During that time, he witnessed first-hand the incredible
                difference that dedicated mentoring and youth support can make
                in a young person's life.
                <br />
                Seeing young people grow in confidence, overcome challenges, and
                achieve positive outcomes left a lasting impression. It became
                clear that organisations like Ignite Life provide a lifeline for
                families at a time when funding for youth services continues to
                face significant challenges.
              </div>
              <div className="content text-primary-1">
                Ashley also saw the remarkable support Ignite Life provided to
                families throughout the COVID-19 pandemic, helping those facing
                some of the most difficult circumstances with compassion,
                practical assistance, and hope.
                <br />
                Choosing Ignite Life as AK Mortgages' charity partner was
                therefore a natural decision. It reflects our belief that
                everyone deserves the opportunity to build a secure future,
                whether that's through finding the right mortgage or accessing
                the support they need during difficult times.
              </div>
            </div>
          </div>
          <img src={CharityPartners2} alt="Community support through Ignite Life" className="hero-image" />
        </div>
      </div>{" "}
      <div className="background-container bg-white">
        <div className="content-container row gap-xxxxxl">
          <img src={CharityPartners3} alt="AK Mortgages and Ignite Life making a difference together" className="hero-image" />
          <div className="column gap-l">
            <h2 className="text-primary-1 uppercase">
              MAKING A DIFFERENCE TOGETHER
            </h2>
            <div className="column gap-m">
              <div className="column gap-s">
                <div className="content text-primary-1">
                  Ignite Life's work extends beyond its everyday services. Each
                  year, the charity hosts its Community Fun Day in Page Park,
                  Staple Hill, bringing local families together while raising
                  vital funds to continue supporting young people across the
                  community. The event also gives the young people they work
                  with the opportunity to get involved, develop new skills, and
                  play an active role in making the day a success.
                </div>
                <div className="content text-primary-1">
                  We are proud to support a charity that is making such a
                  meaningful difference across Bristol and surrounding
                  communities. By working together, we hope to help ensure
                  Ignite Life can continue providing life-changing support to
                  young people and families for many years to come.
                </div>
                <div className="content-semibold text-primary-1">
                  Thank you to everyone who chooses AK Mortgages. Your support
                  helps us continue supporting the communities we proudly serve.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharityPartnerships;
